[
  {
    "id": "SR-M6P-CACTUS-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-C-REGEL-HERKENNEN",
    "conceptId": "c_sound_rule_recognition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "In welk woord klinkt de C als een K?",
    "options": ["cactus", "cent", "cel", "cijfer"],
    "correctAnswer": 0,
    "explanation": "De C-regel: C + a/o/u = K-klank. C + e/i = S-klank. 'Cactus' heeft C + a, dus klinkt het als 'K'.",
    "distractorExplanations": {
      "1": "'Cent' heeft C + e, dus klinkt de C als 'S'.",
      "2": "'Cel' heeft C + e, dus klinkt de C als 'S'.",
      "3": "'Cijfer' heeft C + i, dus klinkt de C als 'S'."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "C-Regel",
        "content": "C + a/o/u = K-klank (cactus, cola, cursus). C + e/i = S-klank (cent, cijfer, circus)",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6P-AMSTERDAM-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "hoofdletter",
    "familyId": "SR-HOOFDLETTER-EIGENNAAM",
    "conceptId": "capital_letter_proper_noun",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord moet met een hoofdletter?",
    "options": ["Amsterdam", "fiets", "dinsdag", "zomer"],
    "correctAnswer": 0,
    "explanation": "Namen van steden, landen en personen schrijf je altijd met een hoofdletter. Amsterdam is een stad.",
    "distractorExplanations": {
      "1": "Gewone voorwerpen krijgen geen hoofdletter.",
      "2": "Dagen van de week krijgen in het Nederlands géén hoofdletter! (Anders dan in het Engels.)",
      "3": "Seizoenen krijgen geen hoofdletter in het Nederlands."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Hoofdletter Regel",
        "content": "Hoofdletters voor: begin van een zin, namen (personen, steden, landen), en het woord 'ik'.",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6P-ACCENT-HERKENNEN-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-ACCENT-HERKENNEN",
    "conceptId": "accent_recognition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een é (met accent)?",
    "options": ["café", "idee", "thee", "koffie"],
    "correctAnswer": 0,
    "explanation": "'Café' is het enige woord met een accent aigu (é). 'Idee', 'thee' en 'koffie' hebben geen accent.",
    "distractorExplanations": {
      "1": "'Idee' heeft geen accent — gewoon twee e's.",
      "2": "'Thee' heeft geen accent — gewoon 'ee'.",
      "3": "'Koffie' heeft geen accent — gewoon '-ie'."
    }
  },
  {
    "id": "SR-M6P-CAFE-INVULLEN-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-ACCENT-CAFE",
    "conceptId": "accent_aigu_loanword",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Vul in: Mijn oom heeft een gezellig caf... in de stad.",
    "options": ["café", "cafe", "cafee", "cafè"],
    "correctAnswer": 0,
    "explanation": "'Café' schrijf je met é (accent aigu). Dit moet je uit je hoofd leren.",
    "distractorExplanations": {
      "1": "Zonder accent is het fout. Het is 'café'.",
      "2": "Twee e's is fout. Het is 'café' met één é.",
      "3": "Dit is een accent grave (è). Café heeft een accent aigu (é)."
    }
  },
  {
    "id": "SR-M6P-CAFE-IDEE-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-ACCENT-CONTRAST",
    "conceptId": "accent_contrast_recognition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welke woorden zijn allebei goed gespeld?",
    "options": ["café en idee", "cafe en idée", "cafè en idee", "café en idé"],
    "correctAnswer": 0,
    "explanation": "'Café' heeft een accent aigu (é), maar 'idee' heeft géén accent. Beide zijn zo correct.",
    "distractorExplanations": {
      "1": "'Cafe' zonder accent is fout. En 'idée' met accent is de oude spelling.",
      "2": "'Cafè' heeft het verkeerde accent (grave in plaats van aigu).",
      "3": "'Idé' met accent is fout. 'Idee' schrijf je gewoon met twee e's."
    }
  },
  {
    "id": "SR-M6P-CADEAU-INVULLEN-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-CADEAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 6,
    "questionType": "multiple_choice",
    "question": "Vul in: Ik heb een mooi ... gekregen voor mijn verjaardag.",
    "options": ["cadeau", "cado", "kadeau", "kado"],
    "correctAnswer": 0,
    "explanation": "'Cadeau' schrijf je met '-eau'. Dit is de correcte standaardspelling.",
    "distractorExplanations": {
      "1": "'Cado' is spreektaal. Op school schrijf je 'cadeau'.",
      "2": "Het begint met 'c', niet met 'k'.",
      "3": "'Kado' is spreektaal en begint met de verkeerde letter."
    }
  },
  {
    "id": "SR-M6P-EAU-HERKENNEN-V01",
    "module": "SpellingRegel",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-HERKENNEN",
    "conceptId": "french_eau_recognition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord eindigt op -eau?",
    "options": ["bureau", "auto", "menu", "euro"],
    "correctAnswer": 0,
    "explanation": "'Bureau' eindigt op '-eau'. Dit is een Frans leenwoord. De andere woorden eindigen op '-o' of '-u'.",
    "distractorExplanations": {
      "1": "'Auto' eindigt op '-o', niet op '-eau'.",
      "2": "'Menu' eindigt op '-u', niet op '-eau'.",
      "3": "'Euro' eindigt op '-o', niet op '-eau'."
    }
  }
]